import Link from 'next/link';
import React from 'react';

type Props = {
    className?: string;
};

export const ExploreEventsCard: React.FC<Props> = ({ className }) => {
    return (
        <div className={`explore-events-card${className ? ` ${className}` : ''}`}>
            <h2 className="card-title">Explore Upcoming Events</h2>
            <p className="card-description">Check out our upcoming events and register today!</p>
            <Link href="/events">
                <a className="button medium-button blue-button">Upcoming Events</a>
            </Link>
        </div>
    );
};
